import { FCM } from '@capacitor-community/fcm'
import { PushNotifications } from '@capacitor/push-notifications'
import { Capacitor } from '@capacitor/core'
import router from '@/router'
import { ref } from 'vue'
import { Settings } from '@/store/index.js'

const registered = ref(false)

async function registerPushNotifications () {
  if (registered.value) return

  await PushNotifications.register()

  // Enable the auto initialization of the library
  await FCM.setAutoInit({ enabled: true })

  // Check the auto initialization status
  // const { enabled } = await FCM.isAutoInitEnabled()
  // console.log('Auto init is ' + (enabled ? 'enabled' : 'disabled'))

  // This will return APNS token on iOS
  // await PushNotifications.addListener('registration', token => {
  //   console.log('Registration token: ', token.value);
  // });

  // PushNotifications.addListener(
  //   'pushNotificationReceived',
  //   (notification) => {
  //     console.log('Push received: ' + JSON.stringify(notification))
  //   }
  // )

  await PushNotifications.addListener(
    'pushNotificationActionPerformed',
    ({ notification }) => {
      const data = notification.data

      if (data?.route) {
        router.push({ name: data.route })
      }
    }
  )

  registered.value = true
}

export default {
  async init () {
    if (!Capacitor.isNativePlatform()) return

    const perm = await PushNotifications.requestPermissions();

    if (perm.receive === 'granted') {
      await registerPushNotifications()
    }
  },

  /**
   * Checks if the user has granted permission to receive notifications
   * @returns {Promise<'granted'|'denied'|'prompt'|false>}
   * */
  async checkPermissions () {
    if (!Capacitor.isNativePlatform()) return false

    const { receive } = await PushNotifications.checkPermissions()
    return receive
  },

  /**
   * Get the FCM token
   * @returns {Promise<{token: ?string}>}
   */
  async getToken () {
    if (Capacitor.isNativePlatform()) {
      const { receive } = await PushNotifications.checkPermissions();
      const enabled = Settings.getNotifications()
      return receive === 'granted' && enabled ? FCM.getToken() : Promise.resolve({ token: null });
    } else {
      return Promise.resolve({ token: null });
    }
  },

  async unregisterPushNotifications () {
    await PushNotifications.removeAllListeners()
    await PushNotifications.unregister()

    await FCM.setAutoInit({ enabled: false })

    registered.value = false
  },

  get registered () {
    return registered.value
  }
}
